module.exports = __webpack_public_path__ + "static/Screenshot (59)-078064de4aa48028b10c8c8e7951b9f2.png";